import axios from 'axios';
import { PUBLISHING_SERVICE_URL } from '../../config';
import { withVersionHeaders } from '../utilities/axiosUtilities';
export function getVersion() {
  const url = `${PUBLISHING_SERVICE_URL}/version`;
  return axios.get(url, withVersionHeaders()).then(({
    data
  }) => data);
}